package com.eladfinish.bible.contest.ui.components.dialogs

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.ui.common.PreviewTheme
import com.eladfinish.bible.contest.ui.models.AlternateRowData
import com.eladfinish.bible.contest.ui.modifiers.alternatingRowBackground
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

@Composable
fun <T> AlternateRowColorsDialog(
    items: ImmutableList<T>,
    itemAsString: @Composable (T) -> String,
    onItemClick: (Int, T) -> Unit,
    modifier: Modifier = Modifier,
) {
    DialogSelectableList(
        modifier = modifier,
        list = items,
        item = { index, item ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .alternatingRowBackground(index)
                    .padding(start = 16.dp)
                    .padding(vertical = 8.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    Text(
                        modifier = Modifier.fillMaxWidth(),
                        text = "${index + 1}. ${itemAsString(item)}",
                        style = MaterialTheme.typography.bodyLarge,
                    )

                    (item as? AlternateRowData)?.subtitle?.let { subtitle ->
                        Text(
                            text = subtitle,
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(top = 2.dp, end = 16.dp),
                            textAlign = TextAlign.Left,
                        )
                    }
                }
            }
        },
        onClick = { index, item ->
            onItemClick(index, item)
        },
    )
}

@Preview
@Composable
private fun PairsMatchingTableOfContentsPreview() {
    val items: List<AlternateRowData> = listOf(
        AlternateRowData(title = "צור זוגות בעצמך", subtitle = "בפיתוח"),
        AlternateRowData(title = "הצגת זוגות כשאלות אמריקאיות", subtitle = "שאלות מכל הרשימות"),
        AlternateRowData(title = "10 דורות מאדם עד נח וגיל הולדה", subtitle = "בראשית ה\'"),
        AlternateRowData(title = "10 דורות מאדם עד נח ושנות חיים אחרי הולדה", subtitle = "בראשית ה\'"),
        AlternateRowData(title = "10 דורות מאדם עד נח ושנות חיים", subtitle = "בראשית ה\'"),
        AlternateRowData(title = "הולדות בני נח", subtitle = "בראשית י\'"),
        AlternateRowData(title = "9 דורות משם עד תרח וגיל הולדה", subtitle = "בראשית י\"א"),
        AlternateRowData(title = "9 דורות משם עד תרח ושנות חיים אחרי הולדה", subtitle = "בראשית י\"א"),
        AlternateRowData(title = "מלחמת המלכים בימי אברם", subtitle = "בראשית י\"ד"),
    )

    PreviewTheme {
        AlternateRowColorsDialog(
            items = items.toImmutableList(),
            itemAsString = { it.title },
            onItemClick = { _, _ -> }
        )
    }
}
